import { Pipe, PipeTransform } from '@angular/core'
import { GbGroupedEntities } from 'libs/shared/models/shared.models'

/**
 * Groups an array of objects by a specified field.
 */
@Pipe({
  name: 'gbGroupBy',
})
export class GbGroupByPipe implements PipeTransform {
  public transform(array: any[], field: string): GbGroupedEntities[] {
    const groupedByField = array.reduce((grouped, item) => {
      ;(grouped[item[field]] = grouped[item[field]] || []).push(item)
      return grouped
    }, {})
    return Object.keys(groupedByField).map((key) => ({
      key,
      values: groupedByField[key],
    }))
  }
}
